<template>
<div>
    <base-card overflowVisible v-if="showFlatRateWebmail">
        <div class="text-center">
            <h4 v-html="$t('flatRateWebmail.title')"></h4>
            <p v-html="$t('flatRateWebmail.description', { price: appointmentPrice, currency: currency })"></p>
            <b-row v-if="!patientIsMinorNoPet">
                <b-col v-if="!patientIsCollective" cols="12" class="mb-3">
                    <h5 v-html="$t('forWhoFlatRate')"></h5>
                    <base-select v-model="formData.forWho" :options="forWhoOptions" label="name" valueProp="value" :placeholder="$t('forWhoFlatRate')" @input="changeSelectUser"></base-select>
                </b-col>
                <b-col v-if="showMinorPatientSelector" cols="12" class="mb-3">
                    <h5 v-html="`${$t('selectPatientForFlatRate')}:`"></h5>
                    <base-select v-model="minorPatientId" :options="associatedPatients.patients" label="name" valueProp="idPatient" :placeholder="$t('selectPatientForFlatRate')" @input="onMinorPatientSelected"></base-select>
                    <small><span v-html="$t('patientNotFoundQuestion')"></span> <span class="href" @click="showModalRegisterPatient">{{ $t('clickHere') }}</span></small>
                </b-col>
            </b-row>
            <div v-html="$t('flatRateWebmail.disclaimer')"></div>
            <div class="mt-3" v-html="$t('flatRateWebmail.question')"></div>
            <b-row class="mt-5">
                <b-col cols="12" class="text-center">
                    <base-button class="mr-3" @click="hireFlatRateWebmail">{{ $t('yes') }}</base-button><base-button red @click="$router.push('/patient')">{{ $t('no') }}</base-button>
                </b-col>
            </b-row>
        </div>
    </base-card>
    <services-packages-table v-else-if="showServicesPackagesTable" :data="profServicesPackages" @servicesPackageSelected="goToServicesPackagesPayment($event)"></services-packages-table>
    <base-card v-show="showAppointmentRequestView" overflowVisible>
        <div class="mb-3">
            <h4 v-html="$t('appointmentSummary')"></h4>
            <div v-if="needsSchedule">{{ `${$t('date')}: ${appointmentDateFormatted}` }}</div>
            <div v-if="needsSchedule">{{ `${$t('hour')}: ${appointmentHourFormatted}` }}</div>
            <div v-if="multiRatesSelected.description">{{ `${$t('description')}: ${multiRatesSelected.description}` }}</div>
            <div>{{ `${$t('price')}: ${appointmentPrice} ${currency}` }}</div>
            <div v-if="centerId">{{ `${$t('center')}: ${centerInfo.name}` }}</div>
        </div>
        <base-button class="mb-3" v-if="centerId" @click="showCenterDetails = !showCenterDetails" white>{{ showCenterDetails ? $t('hideCenterDetails') : $t('showCenterDetails') }}</base-button>
        <div class="mb-3" v-if="showCenterDetails">
            <img class="center-photo mb-3" alt="center" :src="centerInfo.photo">
            <h4 style="display: inline-block" v-html="centerInfo.name"></h4>
            <div v-if="centerInfo.address">{{ `${$t('address')}: ${centerInfo.address}` }}</div>
            <div v-if="centerInfo.schedule">{{ `${$t('schedule')}: ${centerInfo.schedule}` }}</div>
            <div v-if="centerInfo.phone">{{ `${$t('phone')}: ${centerInfo.phone}` }}</div>
            <div v-if="centerInfo.services">{{ `${$t('services')}: ${centerInfo.services}` }}</div>
        </div>
        <b-row v-if="isFirstAppointment">
            <b-col cols="12" md="5" class="mb-3">
                <h4 v-html="$t('isFirstAppointmentQuestion')"></h4>
                <base-select v-model="formData.isFirstAppointment" :options="isFirstAppointmentOptions" @input="isFirstAppointmentSelected" label="name" valueProp="value" :placeholder="$t('selectForisFirstAppointmentQuestion')"></base-select>
            </b-col>
        </b-row>
        <b-row class="col-gap" v-if="!patientIsMinorNoPet">
            <b-col v-if="!patientIsCollective" cols="12" md="5" class="mb-3">
                <h4 v-html="$t('forWhoQuestion')"></h4>
                <base-select v-model="formData.forWho" :options="forWhoOptions" label="name" valueProp="value" :placeholder="$t('selectforWhoQuestion')" @input="changeSelectUser"></base-select>
            </b-col>
            <b-col v-if="showMinorPatientSelector" cols="12" md="5" class="mb-3">
                <h4 v-html="`${$t('selectPatientForConsultation')}:`"></h4>
                <base-select v-model="minorPatientId" :options="associatedPatients.patients" label="name" valueProp="idPatient" :placeholder="$t('selectPatientForConsultation')" @input="onMinorPatientSelected"></base-select>
                <small><span v-html="$t('patientNotFoundQuestion')"></span> <span class="href" @click="showModalRegisterPatient">{{ $t('clickHere') }}</span></small>
            </b-col>
            <b-col v-if="showPetSelector" cols="12" md="5" class="mb-3">
                <h4 v-html="`${$t('selectPetForConsultation')}:`"></h4>
                <base-select v-model="formData.pet" :options="associatedPatients.patients" label="name" valueProp="idAnimal" :placeholder="$t('selectPetForConsultation')"></base-select>
            </b-col>
        </b-row>
        <b-row v-if="patientIsCollective">
            <b-col cols="12" md="5" class="mb-3">
                <h4 v-html="$t('nameAuthorizedMinor')"></h4>
                <base-input v-model="formData.nameAuthorizedForMinor" :placeholder="$t('nameAuthorizedMinorPlaceholder')"></base-input>
                <small><span v-html="$t('nameAuthorizedMinorInfo')"></span></small>
            </b-col>
        </b-row>
        <b-row class="col-gap" v-if="showInsurancesRequest">
            <b-col cols="12" md="5" class="mb-3">
                <h4 v-html="$t('insuranceornot')"></h4>
                <base-select v-model="haveInsurance.value" :options="haveInsurance.options" label="name" valueProp="value" :placeholder="$t('insuranceornot')"></base-select>
            </b-col>
            <b-col v-if="showInsurancesOptions" cols="12" md="5" class="mb-3">
                <h4 v-html="`${$t('selectAnInsurer')}:`"></h4>
                <base-select v-model="formData.insurance" :options="profInsurers" label="name" valueProp="id" :placeholder="$t('selectAnInsurer')" @input="showInsuranceForm = true"></base-select>
            </b-col>
        </b-row>
        <b-row class="col-gap" v-if="showInsuranceForm">
            <b-col cols="12" class="mb-3">
                <h4 v-html="$t('insuranceCardDetails')"></h4>
                <base-input class="mb-3" v-model="formData.insuranceCardData.number" :placeholder="$t('insurancecardnumber')"></base-input>
            </b-col>
            <b-col cols="12" md="3" class="mb-3">
                <base-select v-model="formData.insuranceCardData.month" :options="months" label="name" valueProp="value" :placeholder="$t('month')"></base-select>
            </b-col>
            <b-col cols="12" md="3" class="mb-3">
                <base-select v-model="formData.insuranceCardData.year" :options="years" label="name" valueProp="value" :placeholder="$t('year')"></base-select>
            </b-col>
            <b-col cols="12" class="mb-3">
                <base-input v-model="formData.insuranceCardData.holderName" :placeholder="$t('insurancecardHolderName')"></base-input>
            </b-col>
        </b-row>
        <b-row class="col-gap" v-if="showCallInfo">
            <b-col cols="12" md="5" class="mb-3">
                <h4 v-html="$t('prefix')"></h4>
                <base-select clearable v-model="formData.callInfo.prefix" searchable :placeholder="$t('prefix')" :options="phonePrefixOptions" :label="$i18nHelpers.normalizeProp('prefixAndCountry')" valueProp="idCountry"></base-select>
            </b-col>
            <b-col cols="12" md="5" class="mb-3">
                <h4 v-html="$t('phoneShort')"></h4>
                <base-input v-model="formData.callInfo.phone" :placeholder="$t('phone')"></base-input>
            </b-col>
        </b-row>
        <b-row class="col-gap">
            <b-col cols="12" md="5" class="mb-3">
                <h4 v-html="`${$t('selectDisease')}:`"></h4>
                <base-select @search="loadDiseases({search: $event})" clearable :loading="disease.loading" searchable :options="disease.options" v-model="formData.disease.id" @input="onDiseaseSelected" avoidDefaultSort :label="$i18nHelpers.normalizeProp('name')" valueProp="id" :placeholder="$t('selectDisease')"></base-select>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" class="mb-3">
                <h4 v-html="$t('reasonTitle')"></h4>
                <content-editable v-model="formData.reason" :placeholder="$t('reasonPlaceholder')"></content-editable>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" class="mb-3">
                <base-checkbox v-model="formData.shareClinicHistory">{{ $t('shareClinicHistory') }}</base-checkbox>
                <span style="font-weight: bold" v-if="!formData.shareClinicHistory" v-html="$t('noSharedClinicHistoryAdvice')"></span>
            </b-col>
            <b-col cols="12" class="mb-3">
                <base-checkbox v-model="formData.shareClinicHistoryWithCenters">{{ $t('shareClinicHistoryWithCenters') }}</base-checkbox>
            </b-col>
            <b-col cols="12" md="5" v-if="showDocumentsUploader" class="mb-3">
                <upload-file-group-form v-model="formData.localFiles"></upload-file-group-form>
            </b-col>
            <b-col cols="12" v-if="isMedicalSpecialty" class="mb-3">
                <base-checkbox v-model="formData.foreignPatient">{{ $t('englishPrescription') }}</base-checkbox>
            </b-col>
            <b-col cols="12">
                <base-checkbox v-model="formData.termsAccepted" class="mb-3">
                    <span v-html="$t('signupOH.accept-terms-patient')"></span>
                </base-checkbox>
            </b-col>
        </b-row>
        <b-row class="mt-5">
            <b-col cols="12" class="text-center">
                <back-button withoutArrow class="mr-3"></back-button> <base-button @click="remindHealthData" :disabled="continueBtnDisabled">{{ $t('continue') }}</base-button>
            </b-col>
        </b-row>
        <base-dialog v-model="modal.show" :content="modal.content" :okBtnText="modal.okBtnText" :okFn="modal.okFn" :cancelBtnText="modal.cancelBtnText" :cancelFn="modal.cancelFn" :closable="false" @hidden="onModalHidden"></base-dialog>
        <tarifa-plus-disabled-modal v-model="showTarifaPlusDisabledModal" :userId="profId" isProfUser></tarifa-plus-disabled-modal>
        <video-test-modal fromAppointmentRequest v-model="showVideoTestModal" @resultTest="checkVideoTestResult($event)"></video-test-modal>
        <base-modal v-model="showFlatRateWebmailSelectorModal" noCloseOnBackdrop noCloseOnScape hideClose :title="$t('flatRateWebmail.title')">
            <div :class="{'text-center': !$uiHelpers.isMobile}">
                <h5 v-html="$t('flatRateWebmailSelector.question')"></h5>
                <base-radio-group :stacked="$uiHelpers.isMobile" v-model="flatRateWebmailSelector.value" :options="flatRateWebmailSelector.options"></base-radio-group>
                <b-row class="mt-5">
                    <b-col cols="12" class="text-center">
                        <base-button @click="flatRateWebmailSelected">{{ $t('continue') }}</base-button>
                    </b-col>
                </b-row>
            </div>
        </base-modal>
    </base-card>
</div>
</template>

<script>
import { INPLACE, SERVICES_PACKAGES, FLAT_RATE, WRITTEN, CHAT, VIDEO, IMMEDIATE_VIDEO, CALL, AT_HOME, SECOND_OPINION, INSURANCE, APPOINTMENT_REQUEST_TYPES } from '@/constants/consultationTypes'
import { BFormFile } from 'bootstrap-vue'
import BackButton from '@/components/base/buttons/BackButton'
import { FLAT_RATE_WRITTEN_CONSULTATION } from '@/constants/db/subscriptionTypes'
import { VETERINARIAN, PEDIATRICS, LACTATION_CONSULTANT, INFANT_SLEEP_COUNSELING, NUTRITION_DIET, ENDOCRINOLOGY, DERMATOLOGY, SCIENCE_PHYSICAL_ACTIVITY_SPORT, WORK_MEDICINE, INTERNAL_MEDICINE, GP_SPECIALTY_ID, GP_FAMILY_SPECIALTY_ID } from '@/constants/db/specialties'
import BaseDialog from '@/components/base/BaseDialog'
import BaseModal from '@/components/base/BaseModal'
import ContentEditable from '@/components/base/forms/ContentEditable'
import BaseRadioGroup from '@/components/base/forms/BaseRadioGroup.vue'
import moment from 'moment'
import { inMx } from '@/helpers/global.helpers'
import { appointmentDateFormat, getTime } from '@/helpers/date.helpers'
import { getCurrencyByDomain } from '@/constants/currencies'
import { CENTER_DEFAULT_IMAGE } from '@/constants/images'
import { EDUCATIVE_CENTER_CODE_TYPE } from '@/constants/db/companyCodeTypes'
import { MSM_SUBDOMAIN } from '@/constants/subdomains'
import geographyRepository from '@/repositories/GeographyRepository'
// import { inOpensalud360 } from '@/constants/platformNames'
import diseasesRepository from '@/repositories/DiseasesRepository'
import { getFilesAndLinks } from '@/helpers/file.helpers'
import BaseCheckbox from '@/components/base/forms/BaseCheckbox'
import TarifaPlusDisabledModal from '@/components/shared/TarifaPlusDisabledModal.vue'
import ServicesPackagesTable from '@/components/shared/ServicesPackagesTable.vue'
import BaseCard from '@/components/base/ui/BaseCard'
import UploadFileGroupForm from '@/components/base/forms/UploadFileGroupForm'
import accountMixin from '@/mixins/account.mixin'
import appointmentRequestMixin from '@/mixins/appointmentRequest.mixin'
import VideoTestModal from '@/components/video-launcher/Test'
import { ACCEPT, REJECTED, ALERT_IMMEDIATE } from '@/constants/signalRCommands'

const FOR_ME_PATIENT_TYPE = 1
const FOR_MINOR_PATIENT_TYPE = 2
const FOR_PET_PATIENT_TYPE = 3
const COMPANIES_UPPER_HOUR_LIMIT = 8
const COMPANIES_LOWER_HOUR_LIMIT = 20
const FLAT_RATE_NO_OPTION_VALUE = 0
const PATIENT_ROOT_PATH = '/patient'
const CONSULTATIONS_PATH = '/patient/appointments'
const CLINIC_HISTORY_VIEW = 'appointmentRequestClinicHistory'
const PAYMENT_VIEW = 'appointmentRequestPayment'
const CANCEL_ACTION = 'appointments/cancel'

export default {
  components: {
    BaseDialog,
    BaseCheckbox,
    BFormFile,
    BackButton,
    TarifaPlusDisabledModal,
    ContentEditable,
    BaseModal,
    BaseRadioGroup,
    ServicesPackagesTable,
    BaseCard,
    UploadFileGroupForm,
    VideoTestModal
  },
  props: {
    profId: String,
    patientId: String,
    profConsultations: Array,
    profServicesPackages: Array,
    profCenters: Array,
    profSpecialtyId: Number,
    profTarifaPlusEnabled: Boolean,
    appointmentType: [String, Number],
    centerId: String,
    date: Date,
    serviceId: String,
    allowChatFirstAppointment: Boolean,
    associatedPets: Array,
    associatedPatients: Object,
    companiesInfo: Object,
    ePrescription: Boolean,
    profHolidaysDate: Date,
    isFirstAppointment: Boolean,
    isMedicalSpecialty: Boolean,
    minorRestricted: Boolean,
    parentalAdvisory: Boolean,
    includedInServicesPackages: Boolean,
    subscriptions: Array,
    patientHasSpecialCompaniesPrices: Boolean,
    specialCompanyPriceRatio: Number,
    patientPhoneInfo: Object,
    chargeInplaceInPlatform: Boolean,
    profInsurers: Array,
    anyActiveChat: Boolean,
    mustUpdateClinicHistory: Boolean,
    patientPendingCompanyAppointmentId: Number,
    weightUpdated: Boolean,
    companiesInstantVideoPending: Boolean
  },
  data () {
    return {
      showCenterDetails: false,
      showPetSelector: false,
      showFlatRateWebmailSelectorModal: false,
      showCallInfo: false,
      showInsuranceForm: false,
      showTarifaPlusDisabledModal: false,
      showFlatRateWebmail: false,
      showServicesPackagesTable: false,
      showVideoTestModal: false,
      minorPatientId: null,
      continueBtnDisabled: false,
      flatRateWebmailSelector: {
        options: [ { value: CHAT, text: this.$t('flatRateWebmailSelector.chatOption') }, { value: WRITTEN, text: this.$t('flatRateWebmailSelector.writtenOption') }, { value: FLAT_RATE_NO_OPTION_VALUE, text: this.$t('flatRateWebmailSelector.noOption') } ],
        value: null
      },
      multiRatesSelected: {
        id: null,
        price: null,
        minutes: null,
        chargeInPlatform: null,
        typeServiceId: null
      },
      centerInfo: {
        address: null,
        schedule: null,
        phone: null,
        services: null,
        photo: null
      },
      disease: {
        loading: false,
        options: []
      },
      isFirstAppointmentOptions: [{name: this.$t('yes'), value: true}, {name: this.$t('no'), value: false}],
      haveInsurance: {
        value: null,
        options: [{name: this.$t('particular'), value: false}, {name: this.$t('insurance'), value: true}]
      },
      forWhoOptions: [{ name: this.$t('forMe'), value: FOR_ME_PATIENT_TYPE }, { name: this.$t('forLinkedPatient'), value: FOR_MINOR_PATIENT_TYPE }],
      phonePrefixOptions: [],
      showMultiRatesServiceSelected: false,
      modal: {
        show: false,
        content: null,
        okFn: null,
        okBtnText: null,
        cancelFn: null,
        cancelBtnText: null
      },
      nextModal: null,
      formData: {
        isFirstAppointment: null,
        forWho: null,
        pet: null,
        nameAuthorizedForMinor: null,
        disease: {
            id: null,
            name: null
        },
        reason: null,
        appointmentStartDate: null,
        appointmentEndDate: null,
        servicesPackageId: null,
        profIdForWrittenFlatRate: null,
        insurance: null,
        insuranceCardData: {
            number: null,
            month: null,
            year: null,
            holderName: null
        },
        callInfo: {
            prefix: null,
            phone: null
        },
        shareClinicHistory: true,
        shareClinicHistoryWithCenters: false,
        foreignPatient: false,
        files: null,
        links: null,
        localFiles: [],
        termsAccepted: false
      },
      timeoutResponseInmediate: null
    }
  },
  mixins: [accountMixin, appointmentRequestMixin],
  created () {
    this.init()
    this.load()
  },
  computed: {
    showAppointmentRequestView () {
        return !this.showFlatRateWebmail && !this.showServicesPackagesTable
    },
    chargeInplace () {
        return this.chargeInplaceInPlatform || (this.multiRatesSelected.typeServiceId === INPLACE && this.multiRatesSelected.chargeInPlatform)
    },
    consultationItem () {
        return this.profConsultations ? this.profConsultations.find(con => con.active && con.id === this.appointmentType) : null
    },
    patientCompanyServiceActive () {
        return this.companiesInfo.companiesServiceEnabled
    },
    freeCompanyAppointment () {
        return this.patientCompanyServiceActive && !this.copaymentEnabled
    },
    copaymentEnabled () {
        return this.companiesInfo.copaymentEnabled
    },
    profMultiRates () {
        return this.profConsultations && this.profServiceIsEnabled ? this.profConsultations.find(con => con.active && con.ratesRange && con.ratesRange.some(rate => rate.typeServiceId === this.appointmentType)).ratesRange : null
    },
    servicePackageAvailable () {
        switch (this.appointmentType) {
            case IMMEDIATE_VIDEO:
                return this.profServicesPackages.some(item => item.numInmediate > 0 || item.numInmediate === -1)
            case INPLACE:
                return this.profServicesPackages.some(item => item.numInplace > 0 || item.numInplace === -1)
            case VIDEO:
                return this.profServicesPackages.some(item => item.numVideo > 0 || item.numVideo === -1)
            case WRITTEN:
                return this.profServicesPackages.some(item => item.numWebmail > 0 || item.numWebmail === -1)
            case CHAT:
                return this.profServicesPackages.some(item => item.numChat > 0 || item.numChat === -1)
            case SECOND_OPINION:
                return this.profServicesPackages.some(item => item.numOpinion > 0 || item.numOpinion === -1)
            case AT_HOME:
                return this.profServicesPackages.some(item => item.numAway > 0 || item.numAway === -1)
            default:
                return false
        }
    },
    subscribedToWrittens () {
        return this.subscriptions.some(item => item.subscriptionTypeId === FLAT_RATE_WRITTEN_CONSULTATION && item.profId === this.profId)
    },
    currency () {
        return getCurrencyByDomain()
    },
    priceFlatRateWebmail () {
        let flatRateWritten = this.profConsultations.find(item => item.id === WRITTEN && item.flatRateActive)
        return flatRateWritten ? flatRateWritten.flatRatePrice : null
    },
    appointmentDuration () {
        return this.multiRatesSelected.minutes || (this.consultationItem ? this.consultationItem.minutes : null)
    },
    appointmentDateFormatted () {
        return this.date ? appointmentDateFormat(this.date, false, true) : null
    },
    appointmentHourFormatted () {
        return this.date ? `${getTime(this.date)} - ${getTime(moment(this.date).add(this.appointmentDuration, 'm').toDate())}` : null
    },
    enabledFlatRateWebmail () {
        this.profConsultations.some(item => item.id === WRITTEN && item.flatRateActive)
    },
    appointmentPrice () {
        let price = null
        if (this.formData.servicesPackageId) {
            price = this.profServicesPackages.find(item => item.id === this.formData.servicesPackageId).price
        } else if (this.appointmentType === FLAT_RATE) {
            price = this.priceFlatRateWebmail
        } else if (this.freeCompanyAppointment || (this.subscribedToWrittens && (this.appointmentType === WRITTEN || this.appointmentType === CHAT)) || this.includedInServicesPackages) {
            price = 0
        } else if (this.companiesInfo.companiesServiceEnabled && this.copaymentEnabled) {
            price = this.companiesInfo.copaymentPrice
        } else if (this.firstAppointmentPrice !== null) {
            price = this.firstAppointmentPrice
        } else if (this.multiRatesSelected.price !== null) {
            price = this.multiRatesSelected.price
        } else if (this.consultationItem) {
            price = this.consultationItem.rate
        }
        if (this.patientHasSpecialCompaniesPrices && this.specialCompanyPriceRatio !== null) {
            price *= this.specialCompanyPriceRatio
        }
        this.$store.commit('appointmentRequest/setAppointmentPrice', price)
        return price
    },
    freeAppointment () {
        return this.appointmentPrice === 0
    },
    firstAppointmentPrice () {
        if (this.isFirstAppointment && this.formData.isFirstAppointment && this.profServiceIsEnabled) {
            if (this.multiRatesSelected.id) {
                return this.profConsultations.find(item => item.id === this.appointmentType).ratesRange.find(item => item.id === this.multiRatesSelected.id).firstConsultationPrice
            } else {
                return this.profConsultations.find(item => item.active && item.id === this.appointmentType).firstConsultationPrice
            }
        }
        return null
    },
    profServiceIsEnabled () {
        return this.multiRatesSelected.id ? this.profConsultations.some(con => con.active && con.ratesRange && con.ratesRange.some(rate => rate.id === this.multiRatesSelected.id)) : this.profConsultations.some(item => item.active && item.id === this.appointmentType)
    },
    patientIsCollective () {
        return this.companiesInfo.codeType === EDUCATIVE_CENTER_CODE_TYPE
    },
    patientIsMinor () {
        return this.associatedPatients.isMinor
    },
    patientHaveMinors () {
        return !this.patientIsMinor && this.associatedPatients.patients.length > 0
    },
    patientIsMinorNoPet () {
        return this.patientIsMinor && this.profSpecialtyId !== VETERINARIAN
    },
    showInsurancesRequest () {
        return false
        // TODO: Review if second condition only apply to inplace
        // return (this.appointmentType === INPLACE || this.appointmentType === INSURANCE) && (this.multiRatesSelected.id ? !this.profMultiRates.some(item => item.id === this.multiRatesSelected.id && item.chargeInPlatform) : !this.chargeInplaceInPlatform) && !inOpensalud360() && this.profInsurers && this.profInsurers.length > 0
    },
    showInsurancesOptions () {
        return this.showInsurancesRequest && this.haveInsurance.value
    },
    showDocumentsUploader () {
        return this.appointmentType !== CALL
    },
    needsSchedule () {
        return this.appointmentType === INPLACE || this.appointmentType === VIDEO || this.appointmentType === INSURANCE
    },
    months () {
        let months = []
        for (let i = 1; i <= 12; i++) {
            let value = i.toString().padStart(2, '0')
            months.push({ name: value, value: value })
        }
        return months
    },
    years () {
        let years = []
        let currentYear = parseInt(new Date().getFullYear().toString())
        for (let i = currentYear; i <= currentYear + 20; i++) {
            years.push({ name: i.toString(), value: i.toString().substring(2) })
        }
        return years
    },
    showMinorPatientSelector () {
        return this.formData.forWho === FOR_MINOR_PATIENT_TYPE && this.patientHaveMinors
    }
  },
  methods: {
    init () {
        this.continueBtnDisabled = false
        if (this.$store.state.appointmentRequest.formData) this.formData = this.$store.state.appointmentRequest.formData
        if (this.profSpecialtyId === VETERINARIAN && !this.forWhoOptions.some(item => item.id === FOR_PET_PATIENT_TYPE)) {
            this.forWhoOptions.push({ name: this.$t('forPet'), value: FOR_PET_PATIENT_TYPE })
        }
        this.$store.commit('appointmentRequest/setWeightRequired', !this.weightUpdated && [NUTRITION_DIET, ENDOCRINOLOGY, WORK_MEDICINE, INTERNAL_MEDICINE, GP_FAMILY_SPECIALTY_ID, GP_SPECIALTY_ID].includes(this.profSpecialtyId))
        if (this.centerId) {
            this.loadCenterInfo(this.profCenters.find(item => item.id.toLowerCase() === this.centerId.toLowerCase()))
        }
        if (this.appointmentType === FLAT_RATE) {
            if (this.subscribedToWrittens) {
                this.showFlatRateWebmailSelectorModal = true
            } else {
                this.showFlatRateWebmail = true
            }
        }
        if (!this.formData.reason) this.setDefaultReason()
    },
    load () {
        if (!this.checkAppointmentRequestRestrictions()) { return false }
        if (this.serviceId) {
            if (this.appointmentType === SERVICES_PACKAGES) {
                this.goToServicesPackagesPayment(this.serviceId)
            } else {
                this.multiRatesSelected.id = this.serviceId
            }
        }
        if (this.$store.state.appointmentRequest.initData.appointmentType === IMMEDIATE_VIDEO && !this.patientCompanyServiceActive && this.$store.state.appointmentRequest.immediateVideoAcceptedProfId !== this.profId) {
            this.sendImmediateNotification()
        }
        if (this.companiesInfo.appointmentLimit) {
            this.checkCompanyAppointmentLimit(this.companiesInfo)
        }
        this.initMultiRates()
        this.checkServicePackageIncluded()
        this.loadDiseases({init: true})
        if (this.date) {
            this.formData.appointmentStartDate = moment(this.date).toDate()
            this.formData.appointmentEndDate = moment(this.date).add(this.appointmentDuration, 'm').toDate()
        }
    },
    loadCenterInfo (profCenter) {
        this.centerInfo.name = profCenter.center
        this.centerInfo.address = profCenter.address ? `${profCenter.address}, ${profCenter.addressNumber}, ${profCenter.town}, ${profCenter.province}` : null
        this.centerInfo.phone = profCenter.phone
        this.centerInfo.schedule = profCenter.schedule
        this.centerInfo.services = profCenter.services ? profCenter.services.map(item => `${this.$i18nHelpers.normalize(item.name)}, ${item.price} ${this.currency}`).join('<br>') : null
        this.centerInfo.photo = profCenter.photoUri || CENTER_DEFAULT_IMAGE
    },
    showModal (content, okFn = null, okBtnText = null, cancelFn = null, cancelBtnText = null) {
        if (this.modal.show) {
            this.nextModal = { content, okFn, okBtnText, cancelFn, cancelBtnText }
            this.modal.show = false
        } else {
            this.modal.content = content
            this.modal.okFn = okFn
            this.modal.okBtnText = okBtnText
            this.modal.cancelFn = cancelFn
            this.modal.cancelBtnText = cancelBtnText
            this.modal.show = true
        }
    },
    onModalHidden () {
        if (this.nextModal) {
            const { content, okFn, okBtnText, cancelFn, cancelBtnText } = this.nextModal
            this.nextModal = null
            this.showModal(content, okFn, okBtnText, cancelFn, cancelBtnText)
        }
    },
    isFirstAppointmentSelected () {
        if (this.isFirstChatNotAllowed()) {
            return this.showFirstChatNotAllowedModal()
        }
    },
    processFiles (files) {
        return getFilesAndLinks(files)
    },
    checkAppointmentRequestRestrictions () {
        if (this.isImmediateVideoWithPending()) {
            return this.showImmediatePendingModal()
        }
        if (this.isOutdatedAppointment()) {
            return this.showOutdatedAppointmentModal()
        }
        if (this.isMinorRestricted()) {
            return this.showMinorRestrictionModal()
        }
        if (this.isOnHolidays()) {
            return this.showHolidaysRestrictionModal()
        }
        if (this.isImmediateOutOfTime()) {
            return this.showOutOfTimeModal()
        }
        return true
    },
    isImmediateVideoWithPending () {
        return this.appointmentType === IMMEDIATE_VIDEO && this.companiesInstantVideoPending
    },
    isOutdatedAppointment () {
        return this.date && this.date < new Date()
    },
    isMinorRestricted () {
        return this.minorRestricted
    },
    isOnHolidays () {
        return this.profHolidaysDate != null
    },
    isFirstChatNotAllowed () {
        return !this.patientCompanyServiceActive && this.appointmentType === CHAT && this.isFirstAppointment && this.formData.isFirstAppointment && !this.allowChatFirstAppointment
    },
    isImmediateOutOfTime () {
        const localHour = parseInt(moment().format('H'))
        return this.appointmentType === IMMEDIATE_VIDEO &&
            this.companiesInfo.companiesServiceEnabled &&
            (localHour > COMPANIES_LOWER_HOUR_LIMIT || localHour < COMPANIES_UPPER_HOUR_LIMIT)
    },
    showImmediatePendingModal () {
        this.showModal(
            this.$t('companyQueueResponse.pendingConfirm'),
            () => this.$router.push(CONSULTATIONS_PATH)
        )
        return false
    },
    showOutdatedAppointmentModal () {
        this.showModal(
            this.$t('outDateAppointment'),
            () => this.$router.push(PATIENT_ROOT_PATH)
        )
        return false
    },
    showMinorRestrictionModal () {
        this.showModal(
            this.$t('requestLimitModal.minorRestricted'),
            () => this.$router.push({ name: 'search' })
        )
        return false
    },
    showHolidaysRestrictionModal () {
        this.showModal(
            this.$t('requestLimitModal.profInHolidays', { date: this.holidaysDate }),
            () => this.$router.push({ name: 'search' })
        )
        return false
    },
    showFirstChatNotAllowedModal () {
        this.showModal(
            this.$t('requestLimitModal.noAllowFirstChat'),
            () => this.$router.push({ name: 'search' })
        )
        return false
    },
    showOutOfTimeModal () {
        const timeZone = inMx ? this.$t('mxHour') : this.$t('spanishHour')
        this.showModal(
            this.$t('requestLimitModal.outOfTime', { timeZone }),
            () => this.$router.push({ name: 'search' })
        )
        return false
    },
    showAlreadyConsultationModal () {
        this.showModal(
            this.$t('alreadyConsultation'),
            () => {
                this.$helpers.goToPatientWebApp(`${CANCEL_ACTION}/${this.patientPendingCompanyAppointmentId}`, this.$apiToken)
            },
            this.$t('continue'),
            () => {
                this.$router.push(CONSULTATIONS_PATH)
            },
            this.$t('cancel')
        )
    },
    setDefaultReason () {
        if (this.profSpecialtyId === DERMATOLOGY) {
            this.formData.reason = this.$t('reasonDerma')
        } else if (!this.isFirstAppointment && (this.profSpecialtyId === ENDOCRINOLOGY || this.profSpecialtyId === NUTRITION_DIET)) {
            this.formData.reason = this.$t('reason-nutriendo1')
        } else if (this.profSpecialtyId === SCIENCE_PHYSICAL_ACTIVITY_SPORT) {
            this.formData.reason = this.$t('reason-physical')
        }
    },
    remindHealthData () {
        if (this.minorRestricted) {
            this.$store.dispatch('showInfoAlert', this.$t('minorRestrictedWarning'))
        } else if (this.patientPendingCompanyAppointmentId && this.patientCompanyServiceActive) {
            this.showAlreadyConsultationModal()
        } else if (this.parentalAdvisory) {
            this.showParentalAdvisoryModal()
        } else {
            this.checkAppointmentForm()
        }
    },
    checkCompanyAppointmentLimit (companiesInfo) {
        if (companiesInfo.appointmentLimit.daysExceeded) {
            this.showModal(
                this.$t('daysExceeded360'),
                () => this.$router.push(PATIENT_ROOT_PATH),
                this.$t('understood')
            )
        } else if (companiesInfo.unavailable) {
            this.showModal(
                this.$t('professionalNotOfferMarketplaceAppointments'),
                () => this.$router.push(PATIENT_ROOT_PATH),
                this.$t('understood')
            )
        } else if (companiesInfo.appointmentLimit.copaymentPrice !== null && !companiesInfo.companiesServiceEnabled) {
            this.showModal(
                this.$t('companyServiceNotAllowed')
            )
        } else if ((!companiesInfo.appointmentLimit.restricted && companiesInfo.appointmentLimit.copayment) || (companiesInfo.appointmentLimit.achieved && companiesInfo.appointmentLimit.copayment)) {
            const content = companiesInfo.appointmentLimit.annual ? this.$t('companyAppointmentLimit.limitAchievedWithPriceAnnual', { price: companiesInfo.appointmentLimit.copayment }) : this.$t('companyAppointmentLimit.limitAchievedWithPrice', { price: companiesInfo.appointmentLimit.copayment })

            this.showModal(
                content
            )
        } else if (companiesInfo.companiesServiceEnabled) {
            const content = this.$helpers.getSubdomain() === MSM_SUBDOMAIN ? this.$t('msmAdviceQueue') : this.$t('companiesAdviceQueue')
            this.showModal(content)
        }
    },
    checkAppointmentForm () {
        if (this.appointmentType === CALL && this.formData.callInfo.phone) {
            this.formData.callInfo.phone = this.formData.callInfo.phone.replace(/ /g, '')
        }
        if (!this.profTarifaPlusEnabled) {
            this.showTarifaPlusDisabledModal = true
        } else if (this.appointmentType === CHAT && this.anyActiveChat) {
            this.$store.dispatch('showInfoAlert', this.$t('chatAppointmentActive'))
        } else if (this.isFirstAppointment && this.formData.isFirstAppointment === null) {
            this.$store.dispatch('showInfoAlert', this.$t('decidefirstc'))
        } else if ((this.profSpecialtyId === NUTRITION_DIET || this.profSpecialtyId === ENDOCRINOLOGY) && !this.formData.reason) {
            this.$store.dispatch('showInfoAlert', this.$t('reasonIntact2'))
        } else if (!this.patientIsMinorNoPet && !this.formData.forWho) {
            this.$store.dispatch('showInfoAlert', this.$t('recipentcmissed'))
        } else if (this.profSpecialtyId === VETERINARIAN && !this.formData.pet) {
            this.$store.dispatch('showInfoAlert', this.$t('selectPetConsultation'))
        } else if (!this.formData.disease.id) {
            this.$store.dispatch('showInfoAlert', this.$t('invaliddiseasewarn'))
        } else if (!this.formData.reason) {
            this.$store.dispatch('showInfoAlert', this.$t('cissuemissed'))
        } else if (this.profSpecialtyId === DERMATOLOGY && this.formData.reason === this.$t('reasonDerma')) {
            this.$store.dispatch('showInfoAlert', this.$t('reasonIntact'))
        } else if ((this.profSpecialtyId === ENDOCRINOLOGY || this.profSpecialtyId === NUTRITION_DIET) && this.formData.reason === this.$t('reason-nutriendo1')) {
            this.$store.dispatch('showInfoAlert', this.$t('reasonIntact2'))
        } else if (this.profSpecialtyId === SCIENCE_PHYSICAL_ACTIVITY_SPORT && this.formData.reason === this.$t('reason-physical')) {
            this.$store.dispatch('showInfoAlert', this.$t('reasonIntact2'))
        } else if (this.showInsurancesRequest && this.appointmentType === INPLACE && !this.patientCompanyServiceActive && this.haveInsurance.value === null) {
            this.$store.dispatch('showInfoAlert', this.$t('errorselectinsurance'))
        } else if (this.appointmentType === CALL && !this.formData.callInfo.prefix) {
            this.$store.dispatch('showInfoAlert', this.$t('prefixError'))
        } else if (this.appointmentType === CALL && this.$validators.validate(this.formData.callInfo.phone, ['phone']) === false) {
            this.$store.dispatch('showInfoAlert', this.$t('invalidphonecall'))
        } else if ((this.formData.forWho === FOR_MINOR_PATIENT_TYPE && !this.minorPatientId) || (this.companiesInfo.codeType === EDUCATIVE_CENTER_CODE_TYPE && !this.patientIsMinor && !this.minorPatientId)) {
            this.$store.dispatch('showInfoAlert', this.$t('minorpatientmissed'))
        } else if (this.companiesInfo.codeType === EDUCATIVE_CENTER_CODE_TYPE && !this.patientIsMinor && !this.formData.nameAuthorizedForMinor) {
            this.$store.dispatch('showInfoAlert', this.$t('invalidauthname'))
        } else if (this.showInsurancesRequest) {
            if (!this.haveInsurance.value) {
                this.$store.dispatch('showInfoAlert', this.$t('decideyesnotinsurer'))
            } else if (this.haveInsurance.value && !this.formData.insurance) {
                this.$store.dispatch('showInfoAlert', this.$t('decidewhatinsurer'))
            } else if (this.showInsuranceForm) {
                if (!this.formData.insuranceCardData.number) {
                    this.$store.dispatch('showInfoAlert', this.$t('invalidinsurancecardnumber'))
                } else if (this.formData.insuranceCardData.holderName) {
                    this.$store.dispatch('showInfoAlert', this.$t('insurancecardnomissed'))
                }
            }
        } else if (!this.formData.termsAccepted) {
            this.$store.dispatch('showInfoAlert', this.$t('termswarn'))
        } else if (!this.formData.shareClinicHistory) {
            this.showModal(
                this.$t('shareClinicHistoryAdvice'),
                () => {
                    this.formData.shareClinicHistory = true
                    this.checkVideoTest()
                },
                this.$t('yes'),
                () => {
                    this.checkVideoTest()
                },
                this.$t('no')
            )
        } else {
            this.checkVideoTest()
        }
    },
    checkVideoTest () {
        if (this.appointmentType === VIDEO) {
            this.showModal(
                this.$t('doVideoTest'),
                () => this.showVideoTest(),
                this.$t('yes'),
                () => this.doConfirmHealthData(),
                this.$t('no')
            )
        } else if (this.appointmentType === IMMEDIATE_VIDEO) {
            this.showVideoTest()
        } else {
            this.doConfirmHealthData()
        }
    },
    showVideoTest () {
        this.showVideoTestModal = true
    },
    checkVideoTestResult (success) {
        if (this.appointmentType === IMMEDIATE_VIDEO && !success) {
            this.$store.dispatch('showDangerAlert', this.$t('invalidConsolidateVideo'))
            setTimeout(function () {
                this.$router.push(PATIENT_ROOT_PATH)
            }, 4000)
        } else {
            if (!success) this.$store.dispatch('showDangerAlert', this.$t('videoTestError'))
            this.doConfirmHealthData()
        }
        this.showVideoTestModal = false
    },
    doConfirmHealthData () {
        if (this.profSpecialtyId !== DERMATOLOGY && !this.mustUpdateClinicHistory) {
            if (this.$store.state.appointmentRequest.weightUpdateRequired) {
                this.initPatientHealthSection()
            } else {
                this.showModal(
                    this.$t('questionMandatoryHealthData'),
                    () => this.initPatientHealthSection(),
                    this.$t('yes'),
                    () => this.goToCheckPayment(),
                    this.$t('no')
                )
            }
        } else if (this.profSpecialtyId === DERMATOLOGY && !this.formData.localFiles.length && this.appointmentType !== CHAT) {
            this.showModal(
                this.$t('dermaWithoutFile'),
                () => {},
                this.$t('uploadImages'),
                () => {
                    this.reasonInfoModal()
                },
                this.$t('continueWithoutUploadingImages')
            )
        } else {
            this.reasonInfoModal()
        }
    },
    reasonInfoModal () {
        this.showModal(
            this.$t('reasonInfoDescription'),
            () => this.initPatientHealthSection(),
            this.$t('continue'),
            () => {},
            this.$t('check')
        )
    },
    initPatientHealthSection () {
        if (this.formData.localFiles.length) {
            this.processFiles(this.formData.localFiles).then(result => {
                if (result.files && !this.checkTotalFileSize(result.files)) return
                this.formData.files = result.files
                this.formData.links = result.links
                this.goToView(CLINIC_HISTORY_VIEW)
            })
        } else {
            this.resetFiles()
            this.goToView(CLINIC_HISTORY_VIEW)
        }
    },
    goToView (name) {
        this.setFormData()
        this.$router.push({ name: name })
    },
    setFormData () {
        this.$store.commit('appointmentRequest/setFormData', this.formData)
    },
    goToCheckPayment () {
        if (this.formData.localFiles.length) {
            this.processFiles(this.formData.localFiles).then(result => {
                if (result.files && !this.checkTotalFileSize(result.files)) return
                this.formData.files = result.files
                this.formData.links = result.links
                this.emitCheckPayment()
            })
        } else {
            this.resetFiles()
            this.emitCheckPayment()
        }
    },
    checkTotalFileSize (files, maxSizeMB = 20) {
        const totalSizeBytes = files.reduce((sum, file) => {
            return sum + (file.size || 0)
        }, 0)

        const totalSizeMB = totalSizeBytes / (1024 * 1024)

        if (totalSizeMB > maxSizeMB) {
            this.$store.dispatch('showInfoAlert', this.$t('filesSizeLimitReached', { size: totalSizeMB.toFixed(2), maxSize: maxSizeMB }))
            return false
        }

        return true
    },
    resetFiles () {
        this.formData.files = null
        this.formData.links = null
    },
    emitCheckPayment () {
        this.setFormData()
        this.$emit('checkIfPaymentRequired')
    },
    initMultiRates () {
        if (!this.multiRatesSelected.id) {
            return
        }
        if (this.profMultiRates) {
            let multiRateItem = this.profMultiRates.find(item => item.id === this.multiRatesSelected.id)
            this.multiRatesSelected.price = multiRateItem.price
            this.multiRatesSelected.minutes = multiRateItem.minutes
            this.multiRatesSelected.description = multiRateItem.description
            this.multiRatesSelected.chargeInPlatform = multiRateItem.chargeInPlatform
            this.multiRatesSelected.typeServiceId = multiRateItem.typeServiceId
      }
    },
    changeSelectUser () {
        const minorAdviceSpecialities = [PEDIATRICS, INFANT_SLEEP_COUNSELING, LACTATION_CONSULTANT]
        if (this.profSpecialtyId === VETERINARIAN && this.formData.forWho !== FOR_PET_PATIENT_TYPE) {
            this.$store.dispatch('showInfoAlert', this.$t('mustSelectPet'))
            this.formData.forWho = null
            this.showPetSelector = false
        } else if (this.profSpecialtyId === VETERINARIAN && this.formData.forWho === FOR_PET_PATIENT_TYPE) {
            this.showPetSelector = true
        } else if (this.formData.forWho === FOR_MINOR_PATIENT_TYPE) {
            if (!this.patientHaveMinors) {
                this.showModalRegisterPatient()
            }
        } else if (minorAdviceSpecialities.some(id => id === this.profSpecialtyId)) {
            this.showModal(
                this.$t('minorAdvice')
            )
        }
    },
    onMinorPatientSelected () {
        if (!this.formData.forWho) return
        this.showModal(
            this.$t('patientMinorRedirect'),
            () => this.changeUser(this.minorPatientId),
            this.$t('continue')
        )
    },
    flatRateWebmailSelected () {
        if (this.flatRateWebmailSelector.value === null) {
            this.$store.dispatch('showInfoAlert', this.$t('mustSelectAnOption'))
        } else if (this.flatRateWebmailSelector.value === FLAT_RATE_NO_OPTION_VALUE) {
            this.$router.push(PATIENT_ROOT_PATH)
        } else {
            let appointmentTypeName = null
            for (let [key, value] of Object.entries(APPOINTMENT_REQUEST_TYPES)) {
                if (value === this.flatRateWebmailSelector.value) {
                    appointmentTypeName = key
                    break
                }
            }
            this.goToAppointmentRequestRoute({ profId: this.profId, appointmentType: appointmentTypeName })
        }
    },
    showModalRegisterPatient () {
        this.showModal(
            this.$t('minorRegisterRedirect'),
            () => this.redirectRegisterMinorPatient(),
            this.$t('continue')
        )
    },
    goToServicesPackagesPayment (servicePackageId) {
        this.formData.servicesPackageId = servicePackageId
        this.goToView(PAYMENT_VIEW)
    },
    hireFlatRateWebmail () {
        if (this.minorRestricted) {
            this.$store.dispatch('showInfoAlert', this.$t('requestLimitModal.minorRestricted'))
        } else if (!this.patientIsMinorNoPet && !this.formData.forWho) {
            this.$store.dispatch('showInfoAlert', this.$t('selectforWhoQuestion'))
        } else if (this.formData.forWho === FOR_MINOR_PATIENT_TYPE && !this.minorPatientId) {
            this.$store.dispatch('showInfoAlert', this.$t('minorpatientmissed'))
        } else if (this.parentalAdvisory) {
            this.showParentalAdvisoryModal()
        } else {
            this.formData.profIdForWrittenFlatRate = this.profId
            this.goToView(PAYMENT_VIEW)
        }
    },
    showParentalAdvisoryModal () {
        this.showModal(
            this.$t('parentalAdvisory'),
            () => {
                if (this.appointmentType === FLAT_RATE) {
                    this.formData.profIdForWrittenFlatRate = this.profId
                    this.goToView(PAYMENT_VIEW)
                } else {
                    this.checkAppointmentForm()
                }
            },
            this.$t('parentalAdvisoryContinue'),
            () => {
                this.redirectRegisterMinorPatient()
            },
            this.$t('parentalAdvisoryCancel')
        )
    },
    checkServicePackageIncluded () {
        if (typeof this.appointmentType === 'number') {
            if (this.patientCompanyServiceActive || ((this.appointmentType === WRITTEN || this.appointmentType === CHAT) && this.subscribedToWrittens)) {
                this.showCallInfo = this.appointmentType === CALL
            } else if (this.includedInServicesPackages) {
                this.$store.dispatch('showInfoAlert', this.$t('servicePackageIncluded'))
                this.showCallInfo = this.appointmentType === CALL
            } else if (!this.profServiceIsEnabled && !this.profMultiRates && this.servicePackageAvailable) {
                this.showModal(
                    this.$t('hireServicePackage'),
                    () => {
                        this.showServicesPackagesTable = true
                    },
                    this.$t('yes'),
                    () => {
                        if ((this.appointmentType === WRITTEN || this.appointmentType === CHAT) && !this.profServiceIsEnabled && this.enabledFlatRateWebmail) {
                            this.showHireFlatRateWebmail()
                        } else {
                            this.$router.push(PATIENT_ROOT_PATH)
                        }
                    },
                    this.$t('no')
                )
            } else if ((this.appointmentType === WRITTEN || this.appointmentType === CHAT) && !this.profServiceIsEnabled && this.enabledFlatRateWebmail) {
                this.showHireFlatRateWebmail()
            } else if (this.servicePackageAvailable) {
                this.showCallInfo = this.appointmentType === CALL
            }
        }
    },
    showHireFlatRateWebmail () {
        this.showModal(
            this.$t('hireFlatRate'),
            () => {
                this.showFlatRateWebmail = true
            },
            this.$t('yes'),
            () => {
                this.$router.push(PATIENT_ROOT_PATH)
            },
            this.$t('no')
        )
    },
    resetModal () {
        this.modal.content = null
        this.modal.okFn = null
        this.modal.okBtnText = null
        this.modal.cancelFn = null
        this.modal.cancelBtnText = null
    },
    redirectRegisterMinorPatient () {
        this.$helpers.goToPatientWebApp('profile', this.$apiToken)
    },
    showModalChangeUser () {
        this.$store.commit('layout/toggleChangeUserModalVisible')
    },
    loadDiseases ({ search = '', init = false } = {}) {
        if (!search && !init) return
        this.disease.loading = true
        const query = init ? (this.formData.disease && this.formData.disease.name) || '' : search
        if (!init) {
            this.formData.disease = { id: null, name: null }
        }
        diseasesRepository.getDiseasesByName({ name: query, onlyCIE: false, specialtyId: this.profSpecialtyId, hideLoadingIcon: true }).then((response) => {
            this.disease.options = response.data.data
            this.disease.loading = false
        })
    },
    onDiseaseSelected () {
        const diseaseSelected = this.disease.options.find(d => d.id === this.formData.disease.id)
        if (diseaseSelected) {
            this.formData.disease.name = this.$i18nHelpers.normalize(diseaseSelected.name)
        }
    },
    sendImmediateNotification () {
        const message = `${ALERT_IMMEDIATE};${this.$store.state.appointmentRequest.appointmentData.patientId}`
        this.$store.dispatch('signalr/sendCommand', { userId: this.$store.state.appointmentRequest.initData.profId, message })
        this.showModal(
            this.$t('immediateVideoPendingConfirm')
        )
        this.continueBtnDisabled = true
        this.timeoutResponseInmediate = setTimeout(() => {
            this.$store.dispatch('showInfoAlert', this.$t('professionalImmediateBusy'))
        }, 900000)
    }
  },
  beforeDestroy () {
    if (this.timeoutResponseInmediate) {
        clearTimeout(this.timeoutResponseInmediate)
    }
  },
  watch: {
    'modal.show' (newValue) {
        if (!newValue) {
            this.resetModal()
        }
    },
    showCallInfo (newValue) {
        if (newValue) {
            geographyRepository.getCountries().then(response => {
                this.phonePrefixOptions = response.data
                this.formData.callInfo.prefix = this.patientPhoneInfo.prefix
                this.formData.callInfo.phone = this.patientPhoneInfo.phone
            })
        }
    },
    '$store.state.signalr.commandReceived' ({ command, data }) {
        switch (command) {
            case ACCEPT:
                this.showModal(
                    this.$t('professionalImmediateAccepted')
                )
                this.continueBtnDisabled = false
                clearTimeout(this.timeoutResponseInmediate)
                this.$store.commit('appointmentRequest/setImmediateVideoAcceptedProfId', this.profId)
                break
            case REJECTED:
                setTimeout(() => {
                    this.$store.dispatch('showInfoAlert', this.$t('professionalImmediateBusy'))
                    this.$router.push(PATIENT_ROOT_PATH)
                }, 5000)
                break
        }
    }
  }
}
</script>

<style lang="scss" scoped>
    .center-photo{
        border-radius: 100%;
        padding: 0;
        box-shadow: 14px 14px 25px #0d275029;
        margin: auto;
        margin-bottom: auto;
        max-width: 100%;
        width: 50px;
        height: 50px;
    }
    .href {
        color: $blue;
        text-decoration: underline;
        cursor: pointer;
    }
    .col-gap{
        gap: 1rem;
    }
    /deep/ .form-group{
        margin-bottom: 0;
    }
    /deep/ .custom-checkbox{
        margin: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/appointment-request/AppointmentRequestInit.vue